module.exports = __webpack_public_path__ + "img/pingfen-bg.1ee8d82f.png";